// Deprecated by POR-203, but, Hey kid! Keep this! It's still relevant in creating a simple tab ui.
// Technically speaking, the Messages page is still using this, there's just 1 tab.
import React from 'react';
import { func } from 'prop-types';

import s from './RefreshMsgsButton.css';


const RefreshIcon = ({ className, width, height, iconTitle, id }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      aria-labelledby={id}
viewBox="1225.499 15952.946 20.319 22.417">
      <title id={id}>{iconTitle}</title>
      <path d="M1243.103 15966.163a7.58 7.58 0 0 1-7.9 6.7 7.693 7.693 0 0 1-7.3-7.3 7.6 7.6 0 0 1 7.6-7.9 8.752 8.752 0 0 1 1.6.2l-1.3.5a.853.853 0 0 0-.5 1.2 1.04 1.04 0 0 0 1.3.6l3.4-1.3.4-.1c.4-.1.5-.5.4-.9l-1.4-3.7a1.04 1.04 0 0 0-1.3-.6 1.04 1.04 0 0 0-.6 1.3l.4 1a8.726 8.726 0 0 0-5.9.5 9.628 9.628 0 1 0 13.3 10 .972.972 0 0 0-1-1.1 1.123 1.123 0 0 0-1.2.9z"/>
    </svg>
  );
};

const RefreshMsgsButton = ({ ...props }) => {
  const handleClick = () => {
    props.handleRefreshInbox();
  };

  return (
    <nav className={s.container}>
      <button
        id="refresh__all-messages"
        name="Refresh All Messages"
        onClick={handleClick}
        className={s.component}
      >
        <RefreshIcon
          className={s.icon}
          iconTitle="Refresh"
          id="refresh__all-messages-icon"
          height="20px"
          width="27px"
        />
        Refresh
      </button>
    </nav>
  );
};

RefreshMsgsButton.propTypes = {
  handleRefreshInbox: func,
};

export default RefreshMsgsButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/RefreshMsgsButton/RefreshMsgsButton.js